import {Accordion, AccordionDetails, AccordionSummary, Icon, IconButton, Typography} from "@material-ui/core";
import {ReactNode} from "react";
import styled from "styled-components/macro";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import withStyles from "@material-ui/core/styles/withStyles";
import ToggleProfile from "./ToggleProfile";

const IconLeftAccordionSummary = withStyles({
    expandIcon: {
        order: -1,
        right: '1%',
    },
    root: {
        border: 5,
        borderRadius: 3,
        color: 'white',
        height: 50,
        padding: '0 7px 0 16px',

    }
})(AccordionSummary);

const HeadingTypography = withStyles({
    root: {
        padding: '5px 0 0 0',
    }
})(Typography);

const CloseButtonContainer = styled.div`
  margin-left: auto;
`;

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 10px;
`;

const ProductWidgetContainer = ({   productKey,
                                    title,
                                    onRemove,
                                    children,
                                    canBeRemoved,
                                    productProfile,
                                    deploymentType,
                                    onProfileChange,
                                }: {
    productKey: string;
    title: ReactNode;
    onRemove?: () => void;
    children?: ReactNode;
    canBeRemoved?: boolean;
    productProfile: string;
    deploymentType: string;
    onProfileChange?: (newProfile: string) => void;
}) => {
    const handleProfileChange = (newProfile: string) => {
      if (onProfileChange) {
        onProfileChange(newProfile);
      }
    };
    const productName = typeof title === "string" ? title : (title as ReactNode)?.toString() || "Unnamed Product";

    return (
        <Accordion>
            <IconLeftAccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <HeadingTypography variant="h4">{title}</HeadingTypography>
                <CloseButtonContainer>
                    <IconButton onClick={onRemove} disabled={!canBeRemoved}>
                        <Icon>close</Icon>
                    </IconButton>
                </CloseButtonContainer>
            </IconLeftAccordionSummary>
            <ToggleWrapper>
              <ToggleProfile
                  productProfile={productProfile}
                  productName={productName}
                  deploymentType={deploymentType}
                  onProfileChange={handleProfileChange}
               />
            </ToggleWrapper>
            <AccordionDetails>
                <div>{children}</div>
            </AccordionDetails>
        </Accordion>
    );
};

export default ProductWidgetContainer;
